import { render, staticRenderFns } from "./GramSuggestions.vue?vue&type=template&id=7c9d571c&"
import script from "./GramSuggestions.vue?vue&type=script&lang=js&"
export * from "./GramSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports